import { config, IJsonRpcResponse } from "../api";

interface ISetStripeCustomerResponse extends IJsonRpcResponse {
    result: {
        success: boolean;
        message: string;
    }
}

export const setStripeCustomer = async (
    companyProfileID: number,
    stripeCustomerID: string,
    stripeRegion: number,
) => {
    const params = {
        companyProfileID,
        stripeCustomerID,
        stripeRegion,
    };
    const authToken = config.authToken;
    const res = await fetch(`${config.url}/setStripeCustomer`, {
        body: JSON.stringify(params),
        headers: {
            'Authorization': 'Bearer ' + authToken,
            'Content-Type': 'application/json'
        },
        method: 'post',
        mode: 'cors'
    });
    const body: ISetStripeCustomerResponse = await res.json();
    return body.result;
};
